import { render, staticRenderFns } from "./RoutinesTab.vue?vue&type=template&id=bbeaf17a&scoped=true"
import script from "./RoutinesTab.vue?vue&type=script&lang=js"
export * from "./RoutinesTab.vue?vue&type=script&lang=js"
import style0 from "./RoutinesTab.vue?vue&type=style&index=0&id=bbeaf17a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbeaf17a",
  null
  
)

export default component.exports